var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { concatClassNames } from "../../utils/Functions";
var Option = /** @class */ (function (_super) {
    __extends(Option, _super);
    function Option() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderOption = function (rProps) {
            var _a = _this.props, disabled = _a.disabled, label = _a.label, type = rProps.type, style = rProps.style, className = rProps.className, selected = rProps.selected, onFocus = rProps.onFocus, onBlur = rProps.onBlur, onClick = rProps.onClick, onKey = rProps.onKey;
            return React.createElement("div", { className: concatClassNames(["dolfo-option", disabled ? "disabled" : "", type], className), style: style, onClick: type === "radio" && !disabled ? onClick : null }, type === "radio" ? React.createElement(React.Fragment, null,
                React.createElement("span", { onFocus: onFocus, onBlur: onBlur, tabIndex: !disabled ? 0 : null, onKeyUp: function (e) { return onKey(e, "keyup"); }, className: selected ? "selected" : null },
                    React.createElement(FontAwesomeIcon, { icon: faCheck })),
                " ",
                React.createElement("label", null, label)) : React.createElement("div", { onClick: disabled ? null : onClick, tabIndex: !disabled ? 0 : null, className: selected ? "selected" : null }, label));
        };
        return _this;
    }
    return Option;
}(React.Component));
export { Option };
